import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export function onMinecraftHeartbeat(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.MC_HEARTBEAT, payload);
}
